@if (open) {
    <div
        [attr.id]="id ? (id + '_wrapper') : null"
        [class]="'agpr-message ' + messageClass"
        [ngClass]="{
            'agpr-message-noBottomCornerRadius' : noBottomCornerRadius,
            'agpr-message-autoFit' : autoFit,
            'agpr-message--useWhiteBg': useWhiteBg,
            'agpr-message-noBottomCornerRadius-bannerMessage' : showBannerMessage
        }"
        [class.agpr-message--systemNotification]="isSystemNotification"
        [class.agpr-message--noMargin]="!bottomMargin"
    >
        @if (isSystemNotification) {
            <div
                [attr.id]="id ? (id + '_systemNotification') : null"
                class="agpr-message-systemNotification"
            >
                <i
                    [attr.id]="id ? (id + '_icon') : null"
                    class="agpr-message-icon"
                    [ngClass]="icon || (iconStyle === iconTypes.normal? messageIcon.normal : messageIcon.outline)"
                    aria-hidden="true"
                ></i>
                <div
                    [attr.id]="id ? (id + '_content') : null"
                    class="agpr-message-systemNotification-content"
                >
                    @if (loading) {
                        <div
                            [attr.id]="id ? (id + '_loading') : null"
                            [agprLoading]="true"
                            [agprInlineLoadingIndicator]="true"
                        ></div>
                    }
                    <p
                        [attr.id]="id ? (id + '_title') : null"
                        class="agpr-message-systemNotification-content-title"
                    > {{ systemNotification?.title }} </p>
                    <p
                        [attr.id]="id ? (id + '_text') : null"
                        class="agpr-message-systemNotification-content-message"
                        [@notificationContent]="collapsed ? 'hidden' : 'visible'"
                        (@notificationContent.done)="onToggleDone($event)"
                        [innerHtml]="systemNotification.message ? systemNotification.message : ''"
                    ></p>
                </div>
            </div>
        } @else {
            <div
                [attr.id]="id ? (id + '_display') : null"
                class="agpr-message-display"
            >
                <div
                    [attr.id]="id ? (id + '_container') : null"
                    class="agpr-message-container"
                    [class.agpr-message-container-center]="centerContent"
                >
                    <i
                        [attr.id]="id ? (id + '_icon') : null"
                        class="agpr-message-icon"
                        [ngClass]="icon || (iconStyle === iconTypes.normal? messageIcon.normal : messageIcon.outline)"
                        aria-hidden="true"
                    ></i>
                    @if (loading) {
                        <div
                            [attr.id]="id ? (id + '_loading') : null"
                            class="agpr-message-loading"
                            [agprLoading]="true"
                            [agprInlineLoadingIndicator]="true"
                            [loadingSmallIndicator]="true"
                        ></div>
                    } @else {
                        <div
                            [attr.id]="id ? (id + '_content') : null"
                            [ngClass]="{
                                'agpr-message-content--noContent': !includeContent[type],
                                'agpr-message-content': includeContent[type],
                                'agpr-message-content-center': centerContent
                            }"
                        >
                            <ng-content></ng-content>
                        </div>
                    }
                </div>
                @if (toggleable && !!toggleableContent) {
                    <div
                        [id]="id + '.expandedContent'"
                        class="agpr-message-toggleContent"
                        [ngClass]="{'agpr-message-toggleContent-bannerMessage': showBannerMessage}"
                        [@notificationContent]="collapsed ? 'hidden' : 'visible'"
                        (@notificationContent.done)="onToggleDone($event)"
                    >
                        <ng-container *ngTemplateOutlet="toggleableContent"></ng-container>
                    </div>
                }
            </div>
        }


        @if (toggleable) {
            <button
                [attr.id]="id ? (id + '_toggle') : null"
                class="agpr-message-toggleIcon fa-solid"
                [ngClass]="{
                    'fa-angle-down' : collapsed,
                    'fa-angle-up'   : !collapsed,
                    'agpr-message-bottomIcon'  : closeable,
                    'agpr-message-toggleIcon-bannerToggleIcon'  : bannerIcon,
                    'agpr-message-bottomIcon-bannerToggleIcon'  : bannerIcon && closeable,
                    'agpr-message-bottomIcon-bannerToggleIconWithoutClose' : bannerIcon && !closeable,
                    'agpr-message-bottomIcon-bannerToggleForceTop' : noBottomCornerRadius
                }"
                [attr.aria-label]="'Message.toggleButton.label' | localize"
                [attr.aria-expanded]="!collapsed"
                [attr.aria-controls]="id + '.expandedContent'"
                [agprTooltip]="toggleTooltip"
                [tooltipPosition]="tooltipPosition"
                (click)="toggle($event)"
            ></button>
        }

        @if (closeable && !loading) {
            <button
                class="agpr-message-closeIcon fa-regular fa-duotone fa-xmark"
                [ngClass]="{
                    'agpr-message-closeIcon-bannerCloseIcon': bannerIcon,
                    'agpr-message-closeIcon-bannerCloseIconForceTop' : noBottomCornerRadius
                    }"
                [id]="id ? id + '.close' : null"
                [attr.aria-label]="'close' | localize"
                (click)="dismissMessage($event)"
            ></button>
        }
    </div>
}
